export default `
Когогин Виталий:  [+7 (900) 622-13-27](tel:+79006221327)

Артём Глущенко:  [+7 (905) 273-84-28](tel:+79052738428)

Витовт Кублицкий:  [+7 (999) 999-99-99](tel:+79999999999)

Корнилова Анастасия:  [+7 (800) 555-35-35](tel:+78005553535)`
